export default {
  // 標籤頁
  loginIpSummary: "登錄IP匯總",
  loginIpDetails: "登錄IP明細",
  deviceDetails: "設備明細",

  // 搜索
  ipLocationPlaceholder: "請輸入IP地理位置",
  reset: "重置",
  query: "查詢",

  // 數據統計
  totalData: "共計{count}條數據",

  // 加載
  loading: "拼命加載中",

  // 表格列 - 登錄IP匯總/明細
  ipAddress: "ip地址",
  ipLocation: "IP地理位置",
  loginCount: "登錄次數",
  recentLoginTime: "最近登錄時間",
  loginTime: "登錄時間",
  loginMethod: "登錄方式",
  port: "端口",

  // 表格列 - 設備明細
  deviceName: "設備名",
  deviceId: "Device ID (UUID)",
  client: "客戶端",
  imei: "IMEI",
  mac: "MAC",

  // 空狀態
  noIpData: "當前調證文件中未解析到IP數據",
  noDeviceData: "當前調證文件中未解析到登陸設備數據",

  // 下載
  downloadDetails: "下載數據明細",
  downloadFileName: "數據明細",
};
